import { createStructuredSelector } from 'reselect'
import { connect } from 'react-redux'
import { getIndice } from 'selectors/algolia'
import { getAlgoliaUserToken } from 'selectors/user/cookie'
import { getUserID } from 'selectors/user/session'

const mapStateToProps = createStructuredSelector({
  searchIndice: getIndice,
  algoliaUserToken: getAlgoliaUserToken,
  userId: getUserID,
})

export type AlgoliaConnectorProps = {
  searchIndice: string
  algoliaUserToken: string
  userId: number
}

export default connect(mapStateToProps)
